import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/videos/18585941-Hd.mp4")